import React from 'react'
import useStyles from './style'
import { useDropzone } from 'react-dropzone'
import PermMediaIcon from '@mui/icons-material/PermMedia'
import { Typography } from '@mui/material'
import { useEffect } from 'react'
import _ from 'lodash'

const DropZone = (props) => {
  const { upload, setUploadErros } = props
  const classes = useStyles()
  const maxFileSize = 5242880

  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
  }

  const fileLengthValidator = (file) => {
    if (file.size > maxFileSize) {
      // alert(`File size is larger than ${formatBytes(maxFileSize)}`)
      // dispatch(
      //   showSnackbar({
      //     message: `File size is larger than ${formatBytes(maxFileSize)}`,
      //     autoHideDuration: 3000,
      //     anchorOrigin: {
      //       vertical: 'top',
      //       horizontal: 'right',
      //     },
      //     variant: 'error',
      //   })
      // )
      return {
        code: 'file-too-large',
        message: `File (${file?.name}) size is larger than ${formatBytes(
          maxFileSize
        )}`,
      }
    }
    return null
  }

  const { getRootProps, getInputProps, open, fileRejections } = useDropzone({
    noClick: true,
    noKeyboard: true,
    maxSize: formatBytes(maxFileSize),
    maxFiles: 3,
    multiple: true,
    accept: {
      'image/*': ['.jpeg', '.jpg', '.png'],
    },
    validator: fileLengthValidator,
    onDrop: (acceptedFiles) => {
      if (acceptedFiles?.length < 4) {
        !_.isEmpty(acceptedFiles) && upload(acceptedFiles)
      }
    },
  })

  useEffect(() => {
   // Control too-many-files error repeat
   const rejectionCodes = (arr) =>
   arr.map(({ file, errors }) => errors?.[0]?.code);
   const uniqueRejections = fileRejections.reduce(
     (acc, { file, errors }) =>
       errors?.[0]?.code == "too-many-files" &&
       rejectionCodes(acc)?.includes("too-many-files")
         ? acc
         : [...acc, { file, errors }],
     []
   );

    setUploadErros(uniqueRejections);
  }, [fileRejections, setUploadErros])

  return (
    <>
      <section {...getRootProps()} className={classes.root}>
        <input {...getInputProps()} />
        <section className={classes.container}>
          <div className={classes.icon}>
            <PermMediaIcon />
          </div>
          <div className={classes.label}>
            <Typography variant="body1">Drag & Drop files here or </Typography>
          </div>
          <div className={classes.btn}>
            <Typography onClick={open} variant="body1">
              browse
            </Typography>
          </div>
        </section>
      </section>
    </>
  )
}

export default DropZone
